"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTabListLayout = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const TabList_1 = require("../../designTokens/TabList");
const Wizard_1 = require("../../../Wizard");
const MIN_WIDTH_TAB_LIST_LAYOUT = '63px';
exports.StyledTabListLayout = styled_components_1.default.div `
    flex-shrink: 0;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    overflow-x: hidden;
    overflow-y: auto;

    width: ${({ width }) => (width ? (typeof width === 'string' ? width : `${width}px`) : '195px')};
    min-width: ${MIN_WIDTH_TAB_LIST_LAYOUT};

    ${({ backgroundView = Wizard_1.WIZARD_TABS_BACKGROUND_VIEW.transparent }) => (0, styled_components_1.css) `
        background: ${backgroundView === Wizard_1.WIZARD_TABS_BACKGROUND_VIEW.transparent
    ? 'transparent'
    : TabList_1.tabListTokens.tabListBackgroundColor.getVar()};

        /* Spacer element for border right */
        &:after {
            content: '';
            display: block;
            flex: 1 1 0;
            border-right: ${TabList_1.tabListTokens.tabListBorderWidth.getVar()} solid
                ${TabList_1.tabListTokens.tabListBorderColor.getVar()};
        }
    `}
`;
//# sourceMappingURL=TabListLayout.styles.js.map